module.exports = __webpack_public_path__ + "static/open-drive-bg-7ab1e6fc27a4b36fbcbd1915b24ac2d5.png";